var _metadata, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCountCircles(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 562.5 562.5",
    height: 562.5,
    width: 562.5,
    xmlSpace: "preserve",
    id: "svg4155",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", {
    id: "metadata4161"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs4159"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.25,0,0,-1.25,0,562.5)",
    id: "g4163"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g4165"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4167"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4169",
    style: {
      fill: "#441188",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m 410.8631,145.698 c 43.7972,43.7973 43.7972,114.8067 0,158.604 0,0 -106.5611,106.5611 -106.5611,106.5611 -43.7973,43.7972 -114.8067,43.7972 -158.604,0 0,0 -106.56109,-106.5611 -106.56109,-106.5611 -43.797259,-43.7973 -43.797259,-114.8067 0,-158.604 0,0 106.56109,-106.56109 106.56109,-106.56109 43.7973,-43.797259 114.8067,-43.797259 158.604,0 0,0 106.5611,106.56109 106.5611,106.56109 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4171",
    style: {
      fill: "#ffdd55",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 331.25,225 c 0,-58.5938 -47.6563,-106.25 -106.25,-106.25 -58.5938,0 -106.25,47.6562 -106.25,106.25 0,58.5938 47.6562,106.25 106.25,106.25 58.5937,0 106.25,-47.6562 106.25,-106.25 z M 375,225 C 375,307.8125 307.8125,375 225,375 142.1875,375 75,307.8125 75,225 75,142.1875 142.1875,75 225,75 c 82.8125,0 150,67.1875 150,150 z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.75,0,0,-0.75,0,450)",
    id: "g4173"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4175",
    style: {
      fill: "none",
      stroke: "#ffdd55",
      strokeWidth: 26.66666985,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.41421402,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 300,218.7598 c 44.8677,0 81.2402,36.3725 81.2402,81.2402 0,44.8677 -36.3725,81.2402 -81.2402,81.2402 -44.8677,0 -81.2402,-36.3725 -81.2402,-81.2402 0,-44.8677 36.3725,-81.2402 81.2402,-81.2402 z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCountCircles);
export default __webpack_public_path__ + "static/media/count_circles.f5eec846e2723fa91ec6eeac408ab993.svg";
export { ForwardRef as ReactComponent };